<template>
<div>
    <div class="ibox sombra-light">
        <div class="ibox-title">
            <h5>
                <i class="fal fa-chart-bar"></i> Detalles
            </h5>
        </div>
        <div class="ibox-content">
            <div class="row">
                <div class="col-md-3">Proveedor</div>
                <div class="col-md-3">Metodo</div>
                <div class="col-md-2">Codigo</div>
                <div class="col-md-2">Estado</div>
                <div class="col-md-2">Fecha</div>
                <div class="col-md-3">{{error.auditoria_integracion.proveedor.nombre}}</div>
                <div class="col-md-3">{{error.auditoria_integracion.parametro.metodo}}</div>
                <div class="col-md-2">{{error.auditoria_integracion.id_codigo_integracion}}</div>
                <div class="col-md-2">{{error.estado.nombre}}</div>
                <div class="col-md-2">{{error.auditoria_integracion.created_at}}</div>
            </div>
            <div class="row " style="margin-top:100px">
                <div class="col-5">
                    Request
                </div>
                <div class="col-7">
                    Response
                </div>
                <div class="col-5">
                    {{error.auditoria_integracion.request}}
                </div>
                <div class="col-7">
                    {{error.auditoria_integracion.response}}
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Comentario</label>
                        <div class="input-group">
                            <textarea v-model="comentario" class="mb-2" rows="5" cols="40"></textarea>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Estado</label>
                        <div class="input-group">
                            <select class="custom-select custom-select-sm" v-model="id_estado" style="width:200px; height:35px" name="type">
                                <option v-for="(item, index) in estado_disponibles" :key="index" :value="item.id">{{item.nombre}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="offset-md-6 col-md-6">
                    <b-button block variant="primary" @click="save" class="buscar-info-dashboard">Guardar</b-button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ['error', 'estados'],
    data() {
        return {
            comentario: "",
            id_estado: "",
            estado_disponibles: []
        }
    },
    mounted() {
        this.id_estado = this.error.id_estado;
        this.estados.forEach(element => {
            if (element.id >= this.id_estado) {
                this.estado_disponibles.push(element);
            }
        });
    },
    methods: {
        save() {
            if (this.id_estado == 3 && (this.comentario == "" || this.comentario == null)) {
                this.$swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Debes ingresar un comentario',
                    showConfirmButton: true,
                    timer: 5000,
                });
                return;
            }
            let data = {
                comentario: this.comentario,
                id_estado: this.id_estado,
                id:this.error.id
            }
            axios.post('save', data).then(response => {
                this.$swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Guardado',
                    text: 'con exito',
                    showConfirmButton: true,
                    timer: 1500,
                }).then(result=>{
                    window.history.back();
                });
            }).catch(error => {
                this.$swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Ha ocurrido un error',
                    showConfirmButton: true,
                    timer: 5000,
                });
            })
        }
    },
}
</script>

<style>
.multiselect__tag {
    background: #adadad;
}

.multiselect__tag-icon:after {
    color: black
}

.multiselect__option--highlight {
    background: #707070;
}

.swal2-container {
    z-index: 999999999;
}
</style>
